import api from "./api";

const userService = {
  getUsers: (params) => api.get("/super/admin/users", { params }),

  getUserById: (id) => api.get(`/super/admin/users`, { params: { id } }),
  getAdminUsers: (params) =>
    api.get("/users/all-users", { params }),

  // getUserById: (id) => api.get(`/users/${id}`),

  createUser: (userData) => {
    const roleRaw = userData?.role;
    const roleNorm = typeof roleRaw === "string" ? roleRaw.trim() : roleRaw;
    const roleLower = typeof roleNorm === "string" ? roleNorm.toLowerCase() : "";

    if (roleLower === "admin" || roleLower === "superadmin") {
      // Backend expects "superAdmin" casing in DB, but accepts either; normalize payload for consistency.
      const payload =
        roleLower === "superadmin" ? { ...userData, role: "superAdmin" } : userData;
      return api.post("/super/admin/create-admin", payload);
    }
    if (userData?.role === "teacher" || userData?.role === "hod") {
      const payload = { ...userData };
      if (!payload.departmentId && payload.department) {
        payload.departmentName = payload.department;
      }
      return api.post("/admin/create-teacher-by-admin", payload);
    }
    if (userData?.role === "student") {
      return api.post("/admin/create-student-by-admin", userData);
    }
    return api.post("/users", userData);
  },

  updateUser: (id, userData) => {

    return api.put(`/users/${id}`, userData);
  },

  deleteUser: (id) => api.delete(`/users/delete`, { params: { id } }),

  updateAdminStatus: (id, status) =>
    api.put(`/super/admin/admin-status-update`, { status }, { params: { id } }),

  assignRole: (userId, roleId) =>
    api.post(`/users/${userId}/assign-role`, { roleId }),

  updateProfile: (profileData) => api.put("/users/profile", profileData),

  getDepartmentNames: () => api.get("/institute/get-departments-names"),

  requestContactUpdate: (contactData) =>
    api.post("/users/request-contact-update", contactData),

  approveContactUpdate: (requestId) =>
    api.post(`/users/approve-contact-update/${requestId}`),

  rejectContactUpdate: (requestId, reason) =>
    api.post(`/users/reject-contact-update/${requestId}`, { reason }),

  getStudents: (params) => api.get("/users/students", { params }),

  getTeachers: (params) => api.get("/users/teachers", { params }),

  getStudentsByClass: (classId) => api.get(`/users/students/class/${classId}`),

  getTeachersByDepartment: (departmentId) =>
    api.get(`/users/teachers/department/${departmentId}`),

  importUsers: (fileData, type) =>
    api.post("/users/import", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
      params: { type },
    }),

  exportUsers: async (params) => {
    const firstRes = await api.get("/super/admin/users", { params });
    const firstData = firstRes.data?.data;
    const firstUsers = firstData?.users || firstData || [];
    const pagination = firstData?.pagination;

    let users = Array.isArray(firstUsers) ? firstUsers : [];

    // If paginated and we didn't request a huge limit, fetch remaining pages for a complete export.
    if (pagination?.totalPages && pagination.totalPages > 1) {
      const requestedLimit = Number(params?.limit || pagination.limit || 50);
      const totalPages = Number(pagination.totalPages);

      // If caller already requested a large limit, assume it's intended to fit all.
      const shouldFetchAllPages = requestedLimit < 1000;

      if (shouldFetchAllPages) {
        const pageReqs = [];
        for (let p = 2; p <= totalPages; p++) {
          pageReqs.push(
            api.get("/super/admin/users", {
              params: { ...(params || {}), page: p, limit: requestedLimit },
            })
          );
        }
        const pageResps = await Promise.all(pageReqs);
        const restUsers = pageResps.flatMap(
          (r) => r.data?.data?.users || r.data?.data || []
        );
        users = [...users, ...restUsers];
      }
    }

    const headers = [
      "id",
      "firstName",
      "lastName",
      "email",
      "phoneNumber",
      "role",
      "instituteId",
      "status",
      "createdBy",
      "createdByRole",
    ];

    const csvRows = users.map((u) =>
      [
        u.id,
        u.firstName,
        u.lastName,
        u.email,
        u.phoneNumber,
        u.role,
        u.instituteId,
        u.status,
        u.createdByName || u.createdBy || "",
        u.createdByRole || "",
      ]
        .map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...csvRows].join("\n");

    return new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  },
};

export default userService;
